import { MessageResource } from '@/i18n/messages';
import { z } from 'zod';

export const RePasswordSchema = (
    transDef: (data: keyof MessageResource['System']) => string
) => {
    return z
        .object({
            old: z
                .string({ message: transDef('System_Required') })
                .min(1, { message: transDef('System_Required') }),
            new: z
                .string({ message: transDef('System_Required') })
                .min(1, { message: transDef('System_Required') }),

            confirm_new: z
                .string({ message: transDef('System_Required') })
                .min(1, { message: transDef('System_Required') }),
        })
        .refine(
            (data) => {
                return data.confirm_new === data.new;
            },
            { message: transDef('System_PasswordNotMatch'), path: ['confirm_new'] }
        );
};

export type RePassword = z.infer<ReturnType<typeof RePasswordSchema>>;
